module.exports = __webpack_public_path__ + "static/media/jumping-jack@2x.0f29dd94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/jumping-jack@2x.png
// module id = 1357
// module chunks = 1